module.exports = __webpack_public_path__ + "static/img/tabbar_home_select@2x.d51713d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tabbar_home_select@2x.png
// module id = y2Cy
// module chunks = 1